(() => {
  const modal = document.getElementById("ArticleShareModal");
  if (!modal) {
    return;
  }

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const openTriggers = document.querySelectorAll("[data-share-modal-open]");
  if (!openTriggers.length) {
    return;
  }

  const focusContainer = modal.querySelector("[data-share-modal-container]");
  const closeTriggers = modal.querySelectorAll("[data-share-modal-close]");
  const copyButton = modal.querySelector("[data-share-copy]");
  const copyStatus = modal.querySelector("[data-share-copy-status]");
  const linkInput = modal.querySelector(".share-modal__link-input");
  const nativeShareButton = modal.querySelector("[data-share-native]");
  const shareButtons = modal.querySelectorAll("[data-share-network]");
  const shareUrl = modal.dataset.shareUrl || window.location.href;
  const shareTitle =
    modal.dataset.shareTitle ||
    document.title ||
    "Check out this article from " + window.location.host;
  const defaultCopySuccessMessage = "Link copied to clipboard!";

  const focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  let previousActiveElement = null;
  let isOpen = false;

  const getFocusableElements = () =>
    Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
      if (element.getAttribute("aria-hidden") === "true") {
        return false;
      }

      if (element.hasAttribute("disabled")) {
        return false;
      }

      if (element.classList.contains("hidden")) {
        return false;
      }

      return element.offsetParent !== null || element === focusContainer;
    });

  const handleKeydown = (event) => {
    if (!isOpen) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getFocusableElements();
    if (!focusable.length) {
      return;
    }

    const firstElement = focusable[0];
    const lastElement = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
      return;
    }

    if (document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  const openModal = () => {
    if (isOpen) {
      return;
    }

    previousActiveElement = document.activeElement;
    modal.classList.remove("invisible", "pointer-events-none", "opacity-0");
    modal.classList.add("opacity-100");
    modal.setAttribute("aria-hidden", "false");
    isOpen = true;

    const focusable = getFocusableElements();
    if (focusable.length) {
      focusable[0].focus({ preventScroll: true });
    } else if (focusContainer) {
      focusContainer.focus({ preventScroll: true });
    }

    document.addEventListener("keydown", handleKeydown);
  };

  const closeModal = () => {
    if (!isOpen) {
      return;
    }

    modal.classList.remove("opacity-100");
    modal.classList.add("opacity-0", "pointer-events-none", "invisible");
    modal.setAttribute("aria-hidden", "true");
    isOpen = false;
    document.removeEventListener("keydown", handleKeydown);

    if (previousActiveElement && typeof previousActiveElement.focus === "function") {
      previousActiveElement.focus({ preventScroll: true });
    }
  };

  const showCopyStatus = (message, isError = false) => {
    if (!copyStatus) {
      return;
    }

    copyStatus.textContent = message;
    copyStatus.classList.remove("hidden");
    copyStatus.classList.toggle("text-red-600", isError);
    copyStatus.classList.toggle("text-green-700", !isError);

    window.setTimeout(() => {
      copyStatus.classList.add("hidden");
      copyStatus.classList.remove("text-red-600");
      copyStatus.classList.add("text-green-700");
    }, 2500);
  };

  const copyToClipboard = async (successMessage = defaultCopySuccessMessage) => {
    if (!shareUrl) {
      return;
    }

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else if (linkInput) {
        linkInput.focus();
        linkInput.select();
        document.execCommand("copy");
        linkInput.setSelectionRange(0, 0);
      }
      showCopyStatus(successMessage || defaultCopySuccessMessage);
    } catch (error) {
      showCopyStatus("Could not copy the link. Please copy manually.", true);
    }
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener("transitionend", () => {
    if (isOpen) {
      return;
    }

    modal.scrollTop = 0;
  });

  if (copyButton) {
    copyButton.addEventListener("click", (event) => {
      event.preventDefault();
      copyToClipboard();
    });
  }

  if (shareButtons.length) {
    shareButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const { shareNetwork: network, shareUrl: networkUrl, shareSuccessMessage } = button.dataset;

        if (network === "facebook" || network === "pinterest") {
          if (networkUrl) {
            window.open(networkUrl, "_blank", "noopener,noreferrer");
          }
          closeModal();
          return;
        }

        copyToClipboard(shareSuccessMessage || defaultCopySuccessMessage);
      });
    });
  }

  if (nativeShareButton && typeof navigator.share === "function") {
    nativeShareButton.classList.remove("hidden");
    nativeShareButton.addEventListener("click", async (event) => {
      event.preventDefault();
      try {
        await navigator.share({
          title: shareTitle,
          url: shareUrl,
        });
        closeModal();
      } catch (error) {
        if (error && error.name === "AbortError") {
          return;
        }
        showCopyStatus("Sharing failed. Try copying the link instead.", true);
      }
    });
  }
})();
